<div id="map">
    <div *ngIf="appointmentsData.length === 0 || !focusedTicket?.ticket_content_histories.at(-1).location">
        <div class="nothing-to-display">{{ "appointment.no_map_locations_available" | translate }}</div>
    </div>
</div>
